import AnalyticsPage from 'components/analytics/AnalyticsPage'
import FeedingAnalyticsView from 'components/analytics/feeding-view/FeedingAnalyticsView'
import CattlesPage from 'components/cattles/cattlesPage/CattlesPage'
import CheckUpPage from 'components/cattles/checkupPage/CheckUpPage'
import DigitizationPage from 'components/cattles/digitizationPage/DigitizationPage'
import FatnessPage from 'components/cattles/fatnessPage/FatnessPage'
import LamenessPage from 'components/cattles/lamenessPage/LamenessPage'
import CowPasportPage from 'components/cattles/passportPage/CowPasportPage'
import TreatmentPage from 'components/cattles/treatmentPage/TreatmentPage'
import TrimCheckupPage from 'components/cattles/trimCheckupPage/TrimCheckupPage'
import TrimEditPage from 'components/cattles/trimEditPage/TrimEditPage'
import DeviationPage from 'components/deviations/DeviationPage'
import { FarmDashboard } from 'components/farm-dashboard'

import FillPage from 'components/fill/FillPage'
import FarmFillDonePage from 'components/fill/ui/FarmFillDonePage'
import FarmFillFeedPlan from 'components/fill/ui/FarmFillFeedPlan'
import FarmFillGroups from 'components/fill/ui/FarmFillGroups'
import FarmFillPage from 'components/fill/ui/FarmFillPage'
import FarmFillRation from 'components/fill/ui/FarmFillRation'
import HistoryPage from 'components/history/HistoryPage'
import { LicensesPage } from 'components/licensesPage/LicensesPage'
import MilkYeildPage from 'components/milk-yield/MilkYeildPage'
import { MilkingProcess } from 'components/milking-process/MilkingProcess'
import { MilkingShiftsPage } from 'components/milking-process/shifts-process/MilkingShiftsPage'
import EditPlanPage from 'components/plan/EditPlanPage'
import AddNewRation from 'components/rationSystem/AddNewRation'
import RationVersionComparePage from 'components/rationSystem/RationVersionComparePage'
import RationViewPage from 'components/rationSystem/RationViewPage'

import MilkingSchedulesPage from 'components/settings/components/milking-schedule/MilkingSchedulesPage'
import PlannedEventsPage from 'components/settings/components/planned-events/PlannedEventsPage'

import GroupsPage from 'components/groups/GroupsPage'
import ManagementPage from 'components/settings/ManagementPage'
import SettingPage from 'components/settings/SettingPage'
import GroupPage from 'layouts/GroupPage'
import ProfilePage from 'layouts/ProfilePage'
import RationEditPage from 'layouts/RationEditPage'
import { RationPageEntry } from 'layouts/RationPageEntry'
import ViewPlanPage from 'layouts/ViewPlanPage'

export const routeConfig = [
	{
		path: 'profile',
		component: ProfilePage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'profile/licenses',
		component: LicensesPage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'fill',
		component: FillPage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'fill/:id',
		component: FarmFillPage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'fill/:id/ration',
		component: FarmFillRation,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'fill/:id/ration/:rationkey',
		component: FarmFillRation,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'fill/:id/groups',
		component: FarmFillGroups,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'fill/:id/feedplan',
		component: FarmFillFeedPlan,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'fill/:id/done',
		component: FarmFillDonePage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'settings',
		component: SettingPage,
		permissions: ['can_manage_users'],
		licenses: [],
		redirect: '/error',
	},
	{
		path: 'settings/management/',
		component: ManagementPage,
		permissions: ['can_manage_users'],
		licenses: [],
		redirect: '/error',
	},

	{
		path: 'settings/planned-events/',
		component: PlannedEventsPage,
		permissions: ['can_manage_users'],
		licenses: ['license_limpness'],
		redirect: '/error',
	},

	{
		path: 'settings/milking-schedule',
		component: MilkingSchedulesPage,
		permissions: ['can_manage_users'],
		licenses: [],
		redirect: '/error',
	},

	{
		path: 'feed',
		component: FarmDashboard,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'feed/deviations',
		component: DeviationPage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'feed/analytics',
		component: AnalyticsPage,
		permissions: ['can_view_analytics'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/analytics/feeding',
		component: FeedingAnalyticsView,
		permissions: ['can_view_analytics'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/groups/',
		component: GroupsPage,
		permissions: ['can_view_cattle_groups'],
		licenses: [],
		redirect: '/error',
	},
	{
		path: 'feed/groups/:groupkey',
		component: GroupPage,
		permissions: ['can_view_cattle_groups'],
		licenses: [],
		redirect: '/error',
	},

	{
		path: 'feed/ration',
		component: RationPageEntry,
		permissions: ['can_view_rations'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/ration/create',
		component: AddNewRation,
		permissions: ['can_edit_rations'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/ration/:rationid',
		component: RationViewPage,
		permissions: ['can_view_rations'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/ration/:rationid/edit',
		component: RationEditPage,
		permissions: ['can_edit_rations'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/ration/:rationid/version/:versionid',
		component: RationVersionComparePage,
		permissions: ['can_view_rations'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/plan',
		component: ViewPlanPage,
		permissions: ['can_view_feedplans'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/plan/edit',
		component: EditPlanPage,
		permissions: ['can_edit_feedplans'],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/plan/history',
		component: HistoryPage,
		permissions: [],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'feed/plan/history/:groupkey',
		component: HistoryPage,
		permissions: [],
		licenses: ['license_food_table'],
		redirect: '/error',
	},
	{
		path: 'cattles',
		component: CattlesPage,
		permissions: [],
		licenses: ['license_limpness', 'license_fatness', 'license_identification'],
		redirect: '/error',
	},
	{
		path: 'cattles/lameness',
		component: LamenessPage,
		permissions: [],
		licenses: ['license_limpness'],
		redirect: '/error',
	},
	{
		path: 'cattles/treatment',
		component: TreatmentPage,
		permissions: [],
		licenses: ['license_limpness'],
		redirect: '/error',
	},
	// {
	// 	path: 'cattles/trim',
	// 	component: TrimPage,
	// 	permissions: [],
	// 	licenses: ['license_limpness'],
	// 	redirect: '/error',
	// },
	{
		path: 'cattles/trim/edit',
		component: TrimEditPage,
		permissions: [],
		licenses: ['license_limpness'],
		redirect: '/error',
	},
	{
		path: 'cattles/trim/check-up',
		component: TrimCheckupPage,
		permissions: [],
		licenses: ['license_limpness'],
		redirect: '/error',
	},
	{
		path: 'cattles/lameness/:id/check-up',
		component: CheckUpPage,
		permissions: [],
		licenses: ['license_limpness'],
		redirect: '/error',
	},
	{
		path: 'cattles/fatness',
		component: FatnessPage,
		permissions: [],
		licenses: ['license_fatness'],
		redirect: '/error',
	},
	{
		path: 'cattles/digitization/:cameraId',
		component: DigitizationPage,
		permissions: [],
		licenses: ['license_identification'],
		redirect: '/error',
	},
	{
		path: 'cattles/deffered-digitization/:cameraId',
		component: DigitizationPage,
		permissions: [],
		licenses: ['license_identification'],
		redirect: '/error',
	},
	{
		path: 'cattles/cow/:tagNumber',
		component: CowPasportPage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'milking-process',
		component: MilkingProcess,
		permissions: [],
		licenses: ['license_milking_process_check'],
		redirect: '/error',
	},
	{
		path: 'milking-process/shifts',
		component: MilkingShiftsPage,
		permissions: [],
		licenses: ['license_milking_process_check'],
		redirect: '/error',
	},
	{
		path: 'feed/milk-yield',
		component: MilkYeildPage,
		permissions: [],
		licenses: [],
		redirect: '',
	},
	{
		path: 'feed/widgets',
		component: FarmDashboard,
		permissions: [],
		licenses: [],
		redirect: '',
	},
]
